export default __webpack_public_path__ + "static/media/doctor-in-the-church.259eb63b.svg";